import { Ikon } from '../status/Ikon.tsx';
import { romIkon, romNavn } from './rom.ts';

/**
 * Rom-bryteren (DD-01, DD-02, DD-56 — skall-konsept v0.1). Samme form i begge bredder:
 * en `radiogroup` med ett segment per rom, aldri en nedtrekksmeny som skjuler valget.
 *
 * Den rendres BARE når leietakeren har mer enn ett rom. Med ett rom finnes den ikke i
 * DOM — ikke skjult, ikke grået: et valg med ett alternativ er ikke et valg (DD-02).
 * Ingen leietaker har to rom i dag; rommet Hypoteser er ikke vedtatt, og bare bryteren
 * og lesingen er det («Panelets skall tåler flere arbeidsrom» i tech-decisions.md).
 * Derfor bytter bryteren ingenting ennå — stien er den samme (avvik 20). Navn og ikon per rom
 * eies av `rom.ts`, som filteret i Panelbrukere også leser.
 */
export function Rombryter({ rom, valgt, onVelg, smal = false }: { rom: readonly string[]; valgt: string; onVelg: (rom: string) => void; smal?: boolean }) {
  return (
    <div className={smal ? 'panel-rom panel-rom-smal' : 'panel-rom'} role="radiogroup" aria-label="Arbeidsrom">
      {rom.map((r) => (
        <button key={r} type="button" role="radio" aria-checked={valgt === r} className="panel-rom-valg" onClick={() => onVelg(r)}>
          <Ikon navn={romIkon(r)} />
          {romNavn(r)}
        </button>
      ))}
    </div>
  );
}
